export default __webpack_public_path__ + "static/media/Archer-Medium.88ac96c5.woff";